import { apiService } from './apiService';
import { LogisticsAccommodationPool } from '../types/logistics';

class AccommodationPoolService {
    private readonly endpoint = '/logistics/accommodations';

    async getAccommodationPools(): Promise<LogisticsAccommodationPool[]> {
        const data = await apiService.get<LogisticsAccommodationPool[]>(this.endpoint);
        return data || [];
    }

    async getAccommodationPoolById(id: string): Promise<LogisticsAccommodationPool | null> {
        try {
            return await apiService.get<LogisticsAccommodationPool>(`${this.endpoint}/${id}`);
        } catch (error) {
            console.error(`Error fetching accommodation pool ${id}:`, error);
            return null;
        }
    }

    async createAccommodationPool(pool: Omit<LogisticsAccommodationPool, 'id'>): Promise<LogisticsAccommodationPool> {
        return apiService.post<LogisticsAccommodationPool>(this.endpoint, pool);
    }

    async updateAccommodationPool(id: string, pool: Partial<LogisticsAccommodationPool>): Promise<LogisticsAccommodationPool> {
        return apiService.put<LogisticsAccommodationPool>(`${this.endpoint}/${id}`, pool);
    }

    async deleteAccommodationPool(id: string): Promise<void> {
        return apiService.delete(`${this.endpoint}/${id}`);
    }
}

export const accommodationPoolService = new AccommodationPoolService();
